import { useState, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import ProjectSettingsDialog from "@/screens/app/project/settings/project-settings-dialog/ProjectSettingsDialog";
import { CommonService } from "@/services";
import "./SettingsComponent.scss";

interface SettingsComponentProps {
    className?: string;
}

const SettingsComponent = ({ className }: SettingsComponentProps) => {
    // Hooks
    const [searchParams, setSearchParams] = useSearchParams();

    // State
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);

    // Effects
    useEffect(() => {
        const settingsParam = searchParams.get('settings');
        if (settingsParam) {
            setIsSettingsOpen(true);
        }
    }, [searchParams]);

    // Listen for communication service trigger to open settings with specific category
    useEffect(() => {
        const subscription = CommonService._communications.openSettingsSubject.subscribe((data) => {
            const { category } = data;
            if (category) {
                // Update URL with the specific category using React aware setSearchParams functional update
                setSearchParams((prev) => {
                    const newParams = new URLSearchParams(prev);
                    newParams.set('settings', category);
                    return newParams;
                });
            }
            setIsSettingsOpen(true);
        });

        return () => {
            subscription.unsubscribe();
        };
    }, [setSearchParams]);

    const handleCloseSettings = useCallback(() => {
        setIsSettingsOpen(false);
        // Remove settings parameter from URL when dialog closes using functional update
        setSearchParams((prev) => {
            const newParams = new URLSearchParams(prev);
            newParams.delete('settings');
            return newParams;
        });
    }, [setSearchParams]);


    // Listen for communication service trigger to close settings
    useEffect(() => {
        const subscription = CommonService._communications.closeSettingsSubject.subscribe(() => {
            handleCloseSettings();
        });

        return () => {
            subscription.unsubscribe();
        };
    }, [handleCloseSettings]);





    // Render
    return (
        <div className={`settings-component ${className || ''}`}>
            <ProjectSettingsDialog
                isOpen={isSettingsOpen}
                onClose={handleCloseSettings}
                initialCategory={searchParams.get('settings') || undefined}
            />
        </div>
    );
};

export default SettingsComponent;